    <template>
    <v-container class="container mb-5 mx-5" fill-height align="end">
        <div id="content" class="mt-5">
            <v-img width="7rem" :src="icon"></v-img>          
            <h1>{{title}}</h1>
            <div>{{text}}</div>
        </div>
        <v-row no-gutters id="button" justify="center" >
            <v-btn
                color="#920825"
                class="white--text px-6"
                tile
                :to="href"
            >
                Tovább
            </v-btn>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: "InfoBox",
    props:{
        title:{
            type:String,
            default: ""
        },
        text:{
            type:String,
            default: ""
        },
        icon:{
            type:String,
            default: ""
        },
        href:{
            type:String,
            default: ""
        }
    }
}
</script>
<style scoped>
    .container{
        height: 20rem;
        width: 23rem;
        border-style:solid;
        border-color:black;
        border-width: 1px;
        transition: 1s;
        top: 0;
        
    }
    .container:hover{ 
        background-color: rgba(0, 0, 0, 0.1);
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        top: -10px;
        transition: 1s;
    }
</style>